const qs = require('qs')

class ApiService {
    baseUrl = window.venezialines.ajaxurl;

    request(action, data, method) {
        return axios({
            method: method,
            url: this.baseUrl,
            data: method == 'post' ? qs.stringify({
                ...data,
                action: action,
            }) : null,
            params: method == 'get' ? {
                ...data,
                action: action
            } : null,
            paramsSerializer: function (params) {
                return qs.stringify(params)
            },
        })
    }

    async get(action, data) {
        return this.request(action, data, 'get')
    }

    async post(action, data) {
        return this.request(action, data, 'post')
    }

    async schedule(data) {
        let response = await this.get('get_schedule', data)

        return response.data ? Object.values(response.data) : []
    }

    async prices(data) {
        let response = await this.get('get_prices', data)

        return response.data ? response.data : { out: [], ret: [] }
    }

    async offers(data) {
        let response = await this.get('get_offers', data)

        return response.data ? response.data : { out: [], ret: [] }
    }

    async daytripPrices(data) {
        let response = await this.get('get_daytrip_prices', data)

        return response.data ? response.data : { out: [], ret: [] }
    }

    async daytripOffers(data) {
        let response = await this.get('get_daytrip_offers', data)

        return response.data ? response.data : { out: [], ret: [] }
    }

    async supplements(data) {
        let response = await this.get('get_supplements')

        return response.data ? response.data : []
    }

    async luggageInfo(data) {
        let response = await this.get('get_luggage_info', data)

        return response.data ? response.data : { extra: false, free: 0 }
    }

    async visaRules(data) {
        let response = await this.get('get_visa_rules', data)

        return response.data ? response.data : []
    }

    async visaRule(data) {
        let response = await this.get('get_visa_rule', data)

        return response.data ? response.data : []
    }

    async paymentLink() {
        let response = await this.get('get_payment_link')

        return response.data ? response.data : []
    }

    async booking(data) {
        let response = await this.get('get_booking', data)

        return response.data ? response.data : {}
    }

    async info(data) {
        let response = await this.get('get_info', data)

        return response.data ? response.data : {}
    }

    async transfers(data) {
        let response = await this.get('get_transfers', data)

        return response.data ? response.data : {
            out: { origin: [], destination: [] },
            ret: { origin: [], destination: [] },
        }
    }
}

export default new ApiService 